// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1ZVxg","boxTitle":"Qualiphy_boxTitle__6nxXj","box":"Qualiphy_box__hT1El","toggleWrap":"Qualiphy_toggleWrap__pmzGJ"};